import { useEffect, useState } from "react"
import { UseAuth } from "hook/auth-hook"
import { RestUseCase, ServiceOperationResult } from "service/api/rest/rest-usecase"
import FileLoadPage from "pages/layout/file-load-page"
import ErrorNotAuthorizedPage from "pages/layout/error/error-not-authorized-page"
import { HeaderNavegationList } from "helper/adapter/headerNavigation/header-navegation-adapter"
import { handleRequest } from "service/api/request-common"
import { getEnv } from "helper/window-helper"
import { ResultadoCarga } from "../../../@types/interfaces/analysis/charge/resultado-carga"

export const FileLoadFactory: React.FC = () => {

    const ENDPOINT_CHARGE_ANALYSIS_V2 = getEnv("REACT_APP_END_POINT_ITEM_CHARGE_ANALYSIS_V2")!
    const ENDPOINT_CHARGE_ANALYSIS_VALIDAR = getEnv("REACT_APP_END_POINT_ITEM_CHARGE_ANALYSIS_VALIDAR")!
    const ENDPOINT_CHARGE_INICIAL_V2 = getEnv("REACT_APP_END_POINT_ITEM_CHARGE_INICIAL_V2")!
    const ENDPOINT_CHARGE_INICIAL_VALIDAR = getEnv("REACT_APP_END_POINT_ITEM_CHARGE_INICIAL_VALIDAR")!
    const ENDPOINT_CHARGE_ANALYSIS_USERS = getEnv("REACT_APP_END_POINT_ITEM_CHARGE_ANALYSIS_USERS")!
    const ENDPOINT_EXPORT = getEnv("REACT_APP_END_POINT_FILE_ERROR")!
    const headers = { "Content-Type": "multipart/form-data" }

    async function handleRequestFile(file: File, isArquivoValidado: boolean, endPoint: string): Promise<any> {

        const formData = new FormData()
        formData.append("file", file)
        formData.append("isArquivoValidado", String(isArquivoValidado));

        const response = await new RestUseCase(endPoint).Post_<ServiceOperationResult<ResultadoCarga>>({ data: formData, headers: headers })
        return response;
    }

    async function handleRequestFileValidade(file: File, endPoint: string): Promise<any> {

        const formData = new FormData()
        formData.append("file", file)

        const request = {
                 data: formData,
                headers: headers,
            };

         const response = await new RestUseCase(endPoint)
                        .Post_<ServiceOperationResult<ResultadoCarga>>(request);
        return response
    }

    async function handleRequestFileV2(file: File, isArquivoValidado: boolean, endPoint: string): Promise<any> {

        const formData = new FormData()
        formData.append("file", file)
        formData.append("isArquivoValidado", String(isArquivoValidado));

        const request = {
                 data: formData,
                headers: headers,
            };

         const response = await new RestUseCase(endPoint)
                        .Post_<ServiceOperationResult<ResultadoCarga>>(request);
        return response
    }

    /** VERIFICA PERMISSAO DE ACESSO */
    const { loggedUserData } = UseAuth()
    const [showScreen, updateShowScreen] = useState<boolean>(false)
    useEffect(() => {
        const roleScreen = HeaderNavegationList.filter(header => header.navTitle === "Análise")[0].navItem.filter(item => item.title === "Carga")[0].role

        if (loggedUserData?.role) {
            loggedUserData.role.forEach(value => {
                if (roleScreen.includes(value))
                    updateShowScreen(true)
            })
        }

    }, [loggedUserData])

    return (
        <>
            {showScreen ?
                <FileLoadPage
                    uploadFileAnalysis={async function (params: { file: File; isArquivoValidado: boolean }): Promise<any> {
                        return await handleRequestFileV2(params?.file!, params.isArquivoValidado, ENDPOINT_CHARGE_ANALYSIS_V2)
                    }}
                    uploadFileAnalysisValidate={async function (params: { file: File }): Promise<any> {
                        return await handleRequestFileValidade(params?.file!, ENDPOINT_CHARGE_ANALYSIS_VALIDAR)
                    }}

                    uploadFileRegistrationInitial={async function (params: { file: File; isArquivoValidado: boolean }): Promise<any> {
                        return await handleRequestFileV2(params?.file!, params.isArquivoValidado, ENDPOINT_CHARGE_INICIAL_V2)
                    }}

                    uploadFileRegistrationInitialValidate={async function (params: { file: File }): Promise<any> {
                        return await handleRequestFileValidade(params?.file!, ENDPOINT_CHARGE_INICIAL_VALIDAR)
                    }}

                    uploadFileRegistrationInitialUsers={async function (params: { file: File; isArquivoValidado: boolean; users: string }): Promise<any> {
                        return await handleRequestFile(params?.file!, params.isArquivoValidado, ENDPOINT_CHARGE_ANALYSIS_USERS + params.users)
                    }}

                    exportFile={async function (): Promise<any> {
                        const response = await new RestUseCase(ENDPOINT_EXPORT!).Get()
                        return handleRequest(response)
                    }}
                    companyId={loggedUserData?.companyId ?? 0}
                />
                :
                <ErrorNotAuthorizedPage />
            }
        </>
    )
}
